/**
 * Lightweight bus for FreeSpinsBonus socket celebrations.
 * Consumed by FreeSpinsBonusHost in AppShell.
 */

export interface FreeSpinsBonusGame {
  GameTag: string;
  Name: string;
  VendorName: string;
}

export interface FreeSpinsBonusNotification {
  id: number;
  at: number;
  ProviderName: string;
  Title: string | null;
  FreeRounds: number;
  Games: FreeSpinsBonusGame[];
}

type Listener = () => void;

let latest: FreeSpinsBonusNotification | null = null;
let version = 0;
let nextId = 1;
const listeners = new Set<Listener>();

function notify(): void {
  version += 1;
  for (const listener of listeners) listener();
}

export function publishFreeSpinsBonus(payload: {
  ProviderName?: string | null;
  Title?: string | null;
  FreeRounds: number;
  Games?: FreeSpinsBonusGame[] | null;
}): void {
  latest = {
    id: nextId++,
    at: Date.now(),
    ProviderName: payload.ProviderName?.trim() || '',
    Title: payload.Title?.trim() || null,
    FreeRounds: payload.FreeRounds,
    Games: payload.Games ?? [],
  };
  notify();
}

export function getFreeSpinsBonus(): FreeSpinsBonusNotification | null {
  return latest;
}

export function getFreeSpinsBonusVersion(): number {
  return version;
}

export function clearFreeSpinsBonus(): void {
  if (!latest) return;
  latest = null;
  notify();
}

export function subscribeFreeSpinsBonus(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
